import { BodyText } from "@/components/ui";

export const SurveyMessage = () => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        Autosend survey shown to patient.
      </BodyText>
    </div>
  );
};
